<template>
  <GoogleAdsPopup
    path="/22163595876/RTBGo_Interstitial_Web"
    :size="[1, 1]"
    id="RTBGo_Interstitial_Web"
    style="margin:0 auto;"
  />
</template>

<script>
import GoogleAdsPopup from "../../../popup/googleAdsPopup.vue";
export default {
  data() {
    return {};
  },
  components: {
    GoogleAdsPopup,
  },
};
</script>

<style scoped></style>
